import { deepEqual } from '@direct-frontend/stdlib';
import type { ReactionInstance } from './ReactionInstance';
import { registerInstancesMap } from './globalRegistry';

/**
 * Кэш экземпляров реакций с дедупликацией по параметрам
 */
export class InstanceCache<R, P> {
    private instances: Map<P, ReactionInstance<R, P>> = new Map();

    public constructor() {
        registerInstancesMap(this.instances);
    }

    /**
     * Создать новый экземпляр
     */
    set(param: P, instance: ReactionInstance<R, P>): void {
        this.instances.set(param, instance);
    }

    /**
     * Получить экземпляр по параметру (с резервным глубоким сравнением)
     */
    get(param: P | undefined): ReactionInstance<R, P> | undefined {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- param имеет тип P. Если у реакции нет параметра, то тут будет undefined и это ок
        const typedParam = param as P;

        if (this.instances.has(typedParam)) {
            return this.instances.get(typedParam);
        }

        for (const [instanceParam, instance] of this.instances) {
            if (deepEqual(instanceParam, param, 3)) {
                return instance;
            }
        }

        return undefined;
    }

    /**
     * Удалить экземпляр по параметру (только по ссылочному равенству)
     * Работает наивно, т.е. удалит экземпляр только если параметр тот же самый по ссылке
     */
    remove(param: P): void {
        this.instances.delete(param);
    }

    /**
     * Получить карту всех экземпляров
     */
    getAll(): Map<P, ReactionInstance<R, P>> {
        return this.instances;
    }
}
